var React = require('react');

function Angle (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"fill":"currentColor","points":"70,0 100,0 50,100 20,100"}));
}

Angle.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 100 100","preserveAspectRatio":"none","version":"1.1"};

module.exports = Angle;

Angle.default = Angle;
